import React from 'react';
import ReactSVG from "react-svg";
import {usePages} from "@ignitesales/neuro-application";

//TODO: consider refactoring this to neuro-application for all projects to use
const LoadingDataIcon = () => {
    const { isLoadingNextPage, isAnimatingPages } = usePages();
    const shouldRender = isLoadingNextPage || isAnimatingPages;
    return shouldRender ? <ReactSVG src='/classpath/assets/images/loading.svg' className='loading-page-icon loadingDataIcon' /> : null;
};

export default LoadingDataIcon;
